var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"cw-box-list"},_vm._l((_vm.boxes),function(boxSetInfo,index){return _c('li',{key:index},[_c('cw-box-cell',{attrs:{"boxSetInfo":boxSetInfo,"showProjectInfo":_vm.showProjectInfoInCells},on:{"click":function($event){return _vm.selectionHandler(boxSetInfo)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }